import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";

export default function IntegrationDetail() {
	return (
		<ServiceDetailLayout
			title="Intégration & Interfaçage"
			summarySections={[
				{ id: "intro", label: "Introduction" },
				{ id: "pourquoi", label: "Pourquoi l’intégration ?" },
				{ id: "avantages", label: "Bénéfices pour votre activité" },
				{ id: "solutions", label: "Solutions proposées" },
				{ id: "securite", label: "Sécurité & conformité" },
				{ id: "accompagnement", label: "Accompagnement & support" },
				{ id: "process", label: "Notre Processus" },
				{ id: "faq", label: "FAQ" }
			]}
		>
			<section id="intro">
				<h2>Introduction</h2>
				<p>
					Nous accompagnons les entreprises dans l’intégration de leurs systèmes d’information, la synchronisation de leurs données et l’interfaçage de leurs applications métiers. Notre expertise couvre les architectures SOA, microservices, API REST/GraphQL, ETL et la gestion de flux complexes entre applications internes et partenaires externes.
				</p>
			</section>
			<section id="pourquoi">
				<h2>Pourquoi l’intégration&nbsp;?</h2>
				<p>
					L’intégration permet de fluidifier les échanges de données, d’automatiser les processus et de garantir la cohérence de l’information au sein de votre organisation. Elle favorise l’innovation, la réactivité et la compétitivité, tout en réduisant les risques d’erreurs et de doublons.
				</p>
			</section>
			<section id="avantages">
				<h2>Bénéfices pour votre activité</h2>
				<p>
					• Automatisation des flux et réduction des tâches manuelles<br />
					• Amélioration de la qualité et de la fiabilité des données<br />
					• Accélération de la prise de décision et reporting en temps réel<br />
					• Ouverture vers de nouveaux services et partenaires<br />
					• Sécurisation des échanges et conformité réglementaire
				</p>
			</section>
			<section id="solutions">
				<h2>Solutions proposées</h2>
				<p>
					Nous réalisons des projets d’intégration sur-mesure :<br />
					• Développement d’API, webservices et connecteurs<br />
					• Mise en place de bus applicatifs et orchestrateurs<br />
					• Synchronisation de bases de données et migration de données<br />
					• Interfaçage avec ERP, CRM, outils métiers et partenaires<br />
					• Monitoring, alerting et gestion des incidents<br />
					Chaque solution est adaptée à votre contexte métier et à vos contraintes techniques.
				</p>
			</section>
			<section id="securite">
				<h2>Sécurité & conformité</h2>
				<p>
					Nous appliquons les meilleures pratiques en matière de sécurité des échanges (chiffrement, authentification forte, gestion des droits, audits réguliers) et garantissons la conformité RGPD et sectorielle de vos flux d’information.
				</p>
			</section>
			<section id="accompagnement">
				<h2>Accompagnement & support</h2>
				<p>
					Un chef de projet dédié vous accompagne dans la définition de votre stratégie d’intégration, la rédaction du cahier des charges et la formation de vos équipes. Notre support technique est disponible en continu, avec des engagements de service (SLA) adaptés à vos enjeux critiques et une assistance personnalisée pour chaque incident ou évolution.
				</p>
			</section>
			<section id="process">
				<h2>Notre Processus</h2>
				<ol>
					<li>Audit de l’existant et définition des besoins</li>
					<li>Conception d’architecture et choix des solutions</li>
					<li>Développement, tests et validation métier</li>
					<li>Déploiement, monitoring et optimisation continue</li>
					<li>Formation, documentation et transfert de compétences</li>
				</ol>
			</section>
			<section id="faq">
				<h2>FAQ</h2>
				<p>
					Besoin d’un conseil sur l’intégration de vos systèmes, la synchronisation de vos données ou l’interfaçage de vos applications&nbsp;? Nos consultants sont à votre écoute pour vous apporter des réponses concrètes et des solutions adaptées à votre secteur d’activité.
				</p>
			</section>
		</ServiceDetailLayout>
	);
}
